export default "__VITE_ASSET__c4e0d4df__"